<ng-http-loader spinner="sk-rotationg-plane" [backgroundColor]="'#00823b'"
    [filteredUrlPatterns]="['/sequation-user-api/checkHeartbeat', '/sequation-user-api/refreshToken', '/sequation-job-api/ref-data/what/', '/sequation-job-api/ref-data/where/' ]">
</ng-http-loader>
<router-outlet></router-outlet>
